import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from './logo.jpg';
import LanguageSelector from '@/components/UI/LanguageSelector';
import useCurrentLang from '@/hooks/useCurrentLang';
import { useAppSelector } from '@/redux/store.hook';
import { getAuthSelector } from '@/redux/auth/auth.slice';
import { getAuthenticatedUserDisplayName } from './headerLayout';

const Header = styled.header`
  height: 125px;
  padding: 28px 50px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  .brand {
    margin-top: 12px;
  }
  .brand img {
    width: 675px;
    max-width: 100%;
    height: auto;
  }
  .utilities {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 28px;
  }
  .account {
    display: flex;
    gap: 30px;
    font-size: 20px;
    font-weight: 700;
    color: #1034a4;
  }
  .account a {
    color: #222;
  }
  .account span {
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  @media (max-width: 1000px) {
    height: auto;
    min-height: 100px;
    padding: 20px;
    .brand {
      max-width: 65%;
    }
    .account {
      font-size: 16px;
      gap: 14px;
    }
    .account span {
      display: none;
    }
  }
  @media (max-width: 500px) {
    padding: 16px;
    flex-wrap: wrap;
    .brand {
      max-width: 100%;
    }
    .utilities {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;
export default function PricingHeader() {
  const lang = useCurrentLang();
  const auth = useAppSelector(getAuthSelector);
  return (
    <Header>
      <Link className="brand" to={`/${lang}`}>
        <img src={logo} alt="eBRAM Deal-Making Portal" />
      </Link>
      <div className="utilities">
        <LanguageSelector theme="dark" inline />
        <div className="account">
          {auth.isLogin ? (
            <>
              <span>{getAuthenticatedUserDisplayName(auth.userData)}</span>
              <Link to="/profile/edit">{lang === 'en' ? 'Account' : '帳號'}</Link>
            </>
          ) : (
            <>
              <Link to="/auth/signin">{lang === 'en' ? 'Sign In' : '登入'}</Link>
              <Link to="/auth/signup">{lang === 'en' ? 'Register' : '註冊'}</Link>
            </>
          )}
        </div>
      </div>
    </Header>
  );
}
